import { Instagram, Play, BadgeCheck, Pin } from "lucide-react";
import { Reveal } from "./Reveal";
import { REELS, LOGO } from "./data";
import { useSite } from "@/lib/site";

export const InstagramGrid = () => {
  const { content } = useSite();
  const s = content.settings || {};
  const reels = content.reels?.length ? content.reels : REELS;
  const ordered = [...reels].sort((a, b) => (b.pinned ? 1 : 0) - (a.pinned ? 1 : 0));
  const igUrl = s.instagram_url || "https://www.instagram.com/thebirth.life";

  return (
    <section data-testid="instagram-section" className="border-t border-ink/10 bg-cream/60 py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal className="flex flex-wrap items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <img
              src={LOGO}
              alt="The Birth Life Instagram profile"
              className="h-14 w-14 rounded-full border-2 border-terra/40 object-cover p-0.5"
              data-testid="instagram-avatar"
            />
            <div>
              <p className="flex items-center gap-1.5 font-outfit text-lg font-semibold text-ink" data-testid="instagram-handle">
                {s.instagram_handle || "@thebirth.life"} <BadgeCheck className="h-4 w-4 text-terra" />
              </p>
              <p className="text-sm text-faint">304K followers · daily breastfeeding & birth education</p>
            </div>
          </div>
          <a
            data-testid="instagram-follow-btn"
            href={igUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3 font-outfit text-sm font-semibold text-sand transition-colors duration-300 hover:bg-terra"
          >
            <Instagram className="h-4 w-4" /> Follow on Instagram
          </a>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6" data-testid="instagram-reel-grid">
          {ordered.map((r, i) => (
            <Reveal key={r.id || i} delay={i * 0.08}>
              <a
                data-testid={`instagram-reel-${i}`}
                href={r.url || igUrl}
                onClick={() => window.__tblTrack?.("reel_click", { caption: (r.caption || "").slice(0, 60) })}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative block overflow-hidden rounded-2xl shadow-lift transition-transform duration-500 hover:-translate-y-1.5"
              >
                <img src={r.img} alt={r.caption} className="aspect-[3/4] w-full object-cover" loading="lazy" />
                {r.pinned && (
                  <span className="absolute left-2.5 top-2.5 inline-flex items-center gap-1 rounded-full bg-terra px-2 py-1 text-[10px] font-outfit font-semibold uppercase tracking-wider text-white">
                    <Pin className="h-2.5 w-2.5" /> Top
                  </span>
                )}
                <span className="absolute right-2.5 top-2.5 flex h-7 w-7 items-center justify-center rounded-full bg-black/40 backdrop-blur-sm transition-transform duration-300 group-hover:scale-110">
                  <Play className="h-3 w-3 fill-white text-white" />
                </span>
                <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-ink/85 to-transparent px-3 pb-3 pt-8 text-[11px] font-outfit font-medium leading-snug text-sand">
                  {r.caption}
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
